// src/app/error.tsx
"use client";

import React from "react";

export default function GlobalErrorPage({ error }: { error: Error }) {
  // eslint-disable-next-line no-console
  console.error("Global error:", error);

  return (
    <div className={`py-[240px] text-center`}>
      <h1>Something went wrong!</h1>
      <p>{error.message || "An unexpected error occurred. Please try again later."}</p>
      <p>We are working to fix this issue!</p>
    </div>
  );
}
